export default __webpack_public_path__ + "static/media/codinggame.87e53d67.jpg";